<template>
  <div>
    <div
      class="leo-hidden tablet:leo-flex leo-w-full leo-flex-row leo-bg-white leo-items-center leo-gap-md leo-py-xl leo-px-7xl leo-w-screen"
    >
      <div>
        <a
          :href="termConditionURL"
          target="_blank"
          class="leo-text-sm leo-cursor-pointer leo-text-grey-600 leo-font-semibold"
          >{{ footerProps.termConditionLabel }}</a
        >
      </div>

      <div v-if="isGELS">
        <a
          :href="policiesNoticesURL"
          target="_blank"
          class="leo-text-sm leo-cursor-pointer leo-text-grey-600 leo-font-semibold"
          >{{ footerProps.policiesNoticesLabel }}</a
        >
      </div>

      <div v-if="!isGELS">
        <a
          :href="personalDataProtectionNoticeURL"
          target="_blank"
          class="leo-text-sm leo-cursor-pointer leo-text-grey-600 leo-font-semibold"
          >{{ footerProps.personalDataProtectionNoticeLabel }}</a
        >
      </div>
      <div v-if="!isGELS">
        <a
          :href="PIDMTipsBrochureURL"
          target="_blank"
          class="leo-text-sm leo-cursor-pointer leo-text-grey-600 leo-font-semibold"
          >{{ footerProps.PIDMTipsBrochureLabel }}</a
        >
      </div>
      <div v-if="!isGELS">
        <a
          :href="aboutPIDMProtectionURL"
          target="_blank"
          class="leo-text-sm leo-cursor-pointer leo-text-grey-600 leo-font-semibold"
          >{{ footerProps.aboutPIDMProtection }}</a
        >
      </div>
      <p
        class="leo-text-grey-600 leo-ml-auto leo-text-xs"
        style="max-width: 592px"
      >
        {{ footerProps.copyRights }}
      </p>
    </div>
  </div>
</template>
<script>
import { CommonClass } from "@/mixins";
import { COUNTRY_CODES } from "@/utils/constants";

export default {
  name: "TheFooter",
  components: {},
  mixins: [CommonClass],
  data() {
    return {
      isShow: false,
      isGELS: this.$__checkAppCountry() == COUNTRY_CODES.SG,
      isGELM: this.$__checkAppCountry() == COUNTRY_CODES.MY,
      footerProps: this.$getConstant?.footerProp,
      termConditionURL: this.$_getTncPortalUrlByCountryCode(),
      policiesNoticesURL: process.env.VUE_APP_OTHER_POLICIES_AND_NOTICES_URL,
      personalDataProtectionNoticeURL:
        process.env.VUE_APP_PERSONAL_DATA_PROTECTION_NOTICE_URL,
      PIDMTipsBrochureURL: process.env.VUE_APP_PIDM_TIPS_BROCHURE_URL,
      aboutPIDMProtectionURL: process.env.VUE_APP_ABOUT_PIDM_PROTECTION_URL,
    };
  },
  methods: {},
};
</script>
